import dateNow from "./dateNow";

const easeOutExpo = pos => (pos === 1 ? 1 : -(2 ** (-10 * pos)) + 1);

const getEndPosition = node => {
  const rect = node.getBoundingClientRect();

  if (rect.height > window.innerHeight) {
    return rect.top + window.scrollY;
  }

  return rect.top - (window.innerHeight / 2 - rect.height / 2) + window.scrollY;
};

const scrollToNode = node => {
  const startPosition = window.scrollY;
  const endPosition = getEndPosition(node);
  const startTime = dateNow();
  const endTime = startTime + 1000;
  let interrupted = false;
  let position;
  const handleInterrupt = () => {
    if (Math.abs(window.scrollY - position) > 1) {
      interrupted = true;
    }
  };

  window.addEventListener("scroll", handleInterrupt);
  const step = () => {
    const now = dateNow();
    const completeness = (now - startTime) / (endTime - startTime);

    position =
      completeness < 1 ? easeOutExpo(completeness) * (endPosition - startPosition) + startPosition : endPosition;

    if (interrupted) {
      window.removeEventListener("scroll", handleInterrupt);
    } else {
      window.scrollTo(0, position);

      if (completeness < 1) {
        window.requestAnimationFrame(step);
      } else {
        window.removeEventListener("scroll", handleInterrupt);
      }
    }
  };

  step();
};

export default scrollToNode;
